<template>
  <v-autocomplete
    v-bind="$attrs"
    :value="value"
    :items="options"
    :item-value="itemValue"
    item-text="name"
    :label="label"
    :multiple="multiple"
    :clearable="clearable"
    :small-chips="multiple"
    :deletable-chips="multiple"
    :filter="matchesSearch"
    outlined
    no-data-text="Inga matchande kategorier"
    :menu-props="{ maxHeight: '60vh' }"
    v-on="$listeners"
  >
    <template v-slot:item="{ item, attrs }">
      <v-list-item-action v-if="multiple">
        <v-icon :color="attrs.inputValue ? 'secondary' : undefined">
          {{ attrs.inputValue ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
        </v-icon>
      </v-list-item-action>
      <v-list-item-icon class="mr-4">
        <v-icon :color="item.color">{{ item.icon_class_name || item.icon || 'mdi-map-marker-outline' }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ item.name }}</v-list-item-title>
        <v-list-item-subtitle v-if="item.description">{{ item.description }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <template v-if="$scopedSlots.selection" v-slot:selection="selection">
      <slot name="selection" v-bind="selection"></slot>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'CategorySelect',
  inheritAttrs: false,
  props: {
    value: { type: [Number, String, Object, Array], default: null },
    items: { type: Array, required: true },
    itemValue: { type: String, default: 'id' },
    label: { type: String, default: 'Välj kategori' },
    multiple: { type: Boolean, default: false },
    clearable: { type: Boolean, default: true }
  },
  computed: {
    options () {
      return this.items.map(item => item.divider || item.header
        ? item
        : {
            ...item,
            name: item.name || item.name_sv || `Kategori ${item.id}`
          })
    }
  },
  methods: {
    matchesSearch (item, query, text) {
      const normalize = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('sv')
      const searchable = normalize(`${text} ${item.id ?? ''} ${item.description || ''}`)
      return normalize(query).trim().split(/\s+/).every(word => searchable.includes(word))
    }
  }
}
</script>
